import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  width: 14px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  border: none;\n  background: none;\n  z-index: 3;\n  position: absolute;\n  top: 14px;\n  right: 15px;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 4;\n  left: 14px;\n  cursor: pointer;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  margin-left: 14px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-radius: 10px;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  width: 100%;\n  height: 44px;\n  padding: 0 46px;\n  border: 0px;\n  border-radius: 100px;\n  color: ", ";\n  box-shadow: ", ";\n  line-height: 1.5;\n\n  ", "\n\n  &[type='search']::-webkit-search-cancel-button,\n  &[type='search']::-webkit-search-decoration {\n    -webkit-appearance: none;\n    appearance: none;\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus,\n  &:hover {\n    outline: 0;\n    border-color: ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    flex: 1;\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  transition: opacity 150ms ease-in-out;\n  width: 100%;\n  z-index: 2;\n  ", "\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useRef } from 'react';
import { AcornsIcon } from '@acorns/icons';
import MediaQuery from 'react-responsive';
import styled, { css } from '../../utils/styling/styled-components';
import { theme } from '../../theme';
import { SEARCH_BAR, SEARCH_BAR_INPUT } from '../../utils/testing/TestIDs';
var Container = styled.div(_templateObject(), function (props) {
  return props.isActive && 'z-index: 199;';
});
var Input = styled.input(_templateObject2(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.shadows.smMedium;
}, function (props) {
  return props.searchType === 'secondary' && css(_templateObject3(), props.theme.colors.ivory);
}, function (props) {
  return props.theme.colors.stoneLight;
}, function (props) {
  return props.theme.colors.stone;
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.theme.colors.slate;
});
var SearchIcon = styled(AcornsIcon)(_templateObject4());
var Back = styled(AcornsIcon)(_templateObject5());
var ClearButton = styled.button(_templateObject6(), function (props) {
  return !props.visible && 'display: none;';
});
var SearchClear = styled(AcornsIcon)(_templateObject7());
export var SearchBar = function SearchBar(_ref) {
  var focusOnLoad = _ref.focusOnLoad,
      children = _ref.children,
      placeholder = _ref.placeholder,
      handleChange = _ref.handleChange,
      handleKeyPress = _ref.handleKeyPress,
      handleExit = _ref.handleExit,
      handleClick = _ref.handleClick,
      searchString = _ref.searchString,
      handleBlur = _ref.handleBlur,
      handleClear = _ref.handleClear,
      node = _ref.node,
      showOverlay = _ref.showOverlay,
      disabled = _ref.disabled,
      type = _ref.type;
  var inputRef = useRef(null);
  useEffect(function () {
    var _inputRef$current;

    if (focusOnLoad && (inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus)) {
      var _inputRef$current2;

      inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    }
  }, [focusOnLoad]);
  return /*#__PURE__*/React.createElement(Container, {
    isActive: showOverlay,
    "data-testid": SEARCH_BAR,
    ref: node
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    icon: AcornsIcon.Icon.MagnifyingGlass,
    height: 16,
    width: 16
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: theme.breakpoints.sm + 1
  }, showOverlay ? /*#__PURE__*/React.createElement(Back, {
    icon: AcornsIcon.Icon.UtilityArrowLeft,
    onClick: handleExit,
    height: 24,
    width: 24
  }) : /*#__PURE__*/React.createElement(SearchIcon, {
    icon: AcornsIcon.Icon.MagnifyingGlass,
    height: 16,
    width: 16
  })), /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    searchType: type,
    "data-testid": SEARCH_BAR_INPUT,
    placeholder: placeholder,
    onClick: handleClick,
    type: "search",
    onChange: handleChange,
    onKeyPress: handleKeyPress,
    value: searchString,
    onBlur: function onBlur(event) {
      return handleBlur === null || handleBlur === void 0 ? void 0 : handleBlur(event);
    },
    disabled: disabled
  }), /*#__PURE__*/React.createElement(ClearButton, {
    onClick: handleClear,
    visible: searchString.length > 0
  }, /*#__PURE__*/React.createElement(SearchClear, {
    icon: AcornsIcon.Icon.Clear
  })), children);
};